// extracted by mini-css-extract-plugin
export default {"container":"qfQ3UuDm","icon":"jjoPsPYw","header":"nA_2DRMD","content":"NurM4TG2","links":"Nf6rtBjz","link":"TtgJG1j3","agreeButton":"h6zJcax_","declineButton":"GPCV2qVu"};